function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M15.9982 15.4474C11.7577 15.4545 7.69017 17.1422 4.69249 20.1399C1.6948 23.1411 0.00706168 27.2051 0 31.4457C0 31.5904 0.0564934 31.7317 0.162419 31.8376C0.264813 31.94 0.406047 32 0.554342 32H31.4492C31.594 32 31.7352 31.9435 31.8411 31.8376C31.9435 31.7352 32.0035 31.594 32.0035 31.4457C31.9965 27.2051 30.3087 23.1376 27.311 20.1399C24.3063 17.1422 20.2388 15.4545 15.9982 15.4474ZM8.8271 7.17114C8.8271 5.26801 9.5827 3.44257 10.9279 2.10085C12.2732 0.7556 14.0986 0 15.9982 0C17.8978 0 19.7268 0.7556 21.0685 2.10085C22.4138 3.4461 23.1694 5.27154 23.1694 7.17114C23.1694 9.07073 22.4138 10.8997 21.0685 12.2414C19.7233 13.5867 17.8978 14.3423 15.9982 14.3423C14.0986 14.3387 12.2732 13.5831 10.9315 12.2379C9.58623 10.8962 8.83063 9.07073 8.8271 7.17114Z",
  fill: "#8E8B99"
}));

var SvgAccountIcon = function SvgAccountIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgAccountIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/accountIcon.c37df882.svg";
export { ForwardRef as ReactComponent };